import { render, staticRenderFns } from "./TabHead.vue?vue&type=template&id=126efb6c"
import script from "./TabHead.ts?vue&type=script&lang=ts&external"
export * from "./TabHead.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports